const cards = [
  {
    title: '某顶流男星深夜与神秘女子同行引热议',
    desc: '娱记拍到某当红男星深夜现身上海某高端酒店，身旁有一位神秘女子同行，两人互动亲密，引发全网猜测。',
    tag: '明星八卦',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20illustration%20of%20celebrity%20sighting%20at%20night%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20flat%20vector%20style%2C%20city%20night%20silhouette%20background%20with%20soft%20gradients%2C%20elegant%20composition%2C%20warm%20neutral%20lighting%2C%20news%20media%20vibe%2C%20modern%20and%20clean%20design&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '热播综艺录制现场突发状况引观众惊呼',
    desc: '某热门综艺最新一期录制现场发生意外插曲，嘉宾即兴反应笑翻全场，节目组连夜发布声明回应争议。',
    tag: '综艺热闻',
    img: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20illustration%20with%20colorful%20lights%20and%20audience%20silhouettes%2C%20dramatic%20warm%20lighting%2C%20editorial%20flat%20vector%20style%2C%20coral%20and%20amber%20accents%2C%20excitement%20and%20surprise%20atmosphere%2C%20modern%20entertainment%20theme%2C%20clean%20composition&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '短视频平台网红大瓜连环爆网友直呼过瘾',
    desc: '三位知名短视频博主同步爆料，牵出一段错综复杂的网红圈内幕，连续多日霸占热搜榜。',
    tag: '网红动态',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20concept%20illustration%20with%20smartphone%20screens%20showing%20viral%20content%2C%20floating%20like%20hearts%20and%20comment%20bubbles%2C%20warm%20coral%20tone%2C%20editorial%20flat%20vector%20style%2C%20trending%20hashtag%20aesthetic%2C%20modern%20clean%20design&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '年度影视剧口碑榜单出炉多部黑马逆袭',
    desc: '权威影视评分平台发布年中口碑榜，多部小成本剧集凭借扎实剧本和出色演技成功突围，引发行业热议。',
    tag: '影视盘点',
    img: 'https://readdy.ai/api/search-image?query=Film%20and%20television%20awards%20illustration%20with%20golden%20trophy%20and%20movie%20clapperboard%2C%20warm%20amber%20spotlight%20effect%2C%20editorial%20flat%20vector%20style%2C%20elegant%20cinematic%20composition%2C%20soft%20gradient%20background%2C%20modern%20and%20sophisticated%20design&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '乐坛天王携新专辑回归预售成绩破纪录',
    desc: '暌违乐坛三年的天王级歌手携全新概念专辑强势回归，预售开启仅一小时便刷新多项销售纪录。',
    tag: '音乐动态',
    img: 'https://readdy.ai/api/search-image?query=Music%20album%20release%20illustration%20with%20vinyl%20record%20and%20musical%20notes%20floating%2C%20warm%20coral%20and%20amber%20gradients%2C%20editorial%20flat%20vector%20style%2C%20concert%20spotlight%20effect%2C%20rhythmic%20composition%2C%20modern%20pop%20music%20aesthetic&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '国际电影节红毯中国影人阵容豪华亮相',
    desc: '本届国际电影节红毯环节星光熠熠，多位中国电影人携作品亮相，引得海外媒体争相报道。',
    tag: '电影节',
    img: 'https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20illustration%20with%20elegant%20silhouettes%20and%20camera%20flashes%2C%20warm%20amber%20spotlights%2C%20editorial%20flat%20vector%20style%2C%20glamorous%20cinematic%20atmosphere%2C%20soft%20cream%20background%2C%20modern%20and%20sophisticated&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    title: '国民品牌官宣新代言人网友：终于等到你',
    desc: '知名国民消费品牌公布全新代言人身份，引发社交媒体狂欢，话题阅读量三小时内突破五亿。',
    tag: '品牌代言',
    img: 'https://readdy.ai/api/search-image?query=Brand%20endorsement%20announcement%20illustration%20with%20elegant%20product%20display%20and%20spotlight%2C%20warm%20coral%20accent%20colors%2C%20editorial%20flat%20vector%20style%2C%20luxurious%20and%20premium%20feel%2C%20modern%20clean%20composition%2C%20sophisticated%20marketing%20aesthetic&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          热门瓜讯速递
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">最新最热的娱乐八卦与热点资讯一网打尽</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i >= 4 ? 'lazy' : undefined}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 text-sm leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>2.3万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>1.8k
                  </span>
                  <span className="ml-auto text-foreground-300">
                    {i === 0 ? '刚刚' : i === 1 ? '2小时前' : i === 2 ? '5小时前' : `${(i + 1) * 3}小时前`}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}